import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { setTitle } from '../../lib/utils/windowutils';
import Sites from '../../lib/models/sites/sites';
import { ltToast } from '../Common/LTToast';
import Octicon, { CloudUpload } from '@githubprimer/octicons-react';
import Customers from '../../lib/models/Customers';
import qs from 'qs';
import { Link } from 'react-router-dom';

class SiteCreate extends PureComponent {
  static propTypes = {
    history: PropTypes.object.isRequired
  };

  state = {
    validated: false,
    code: '',
    description: '',
    customer_id: '',
    customers: { rows: [] }
  };

  render() {
    const { code, description, customers, customer_id, validated } = this.state;
    return (
      <div>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/admin/">Admin</Link>
            </li>
            <li className="breadcrumb-item">
              <Link to="/admin/sites">Sites</Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Create
            </li>
          </ol>
        </nav>
        <h5 className="mb-3">Create new Site</h5>
        <form onSubmit={this.handleSubmit} className="mb-3 mt-3">
          <div className="row">
            <div className="col-12 col-md-6 col-lg-5">
              <div className="card border-info">
                <div className="card-header bg-info text-white">
                  <strong>Detail</strong>
                </div>
                <div className="card-body">
                  <div className="form-group">
                    <label htmlFor="siteInputCode">Code</label>
                    <input
                      type="text"
                      className="form-control"
                      id="siteInputCode"
                      name="code"
                      placeholder="Enter code"
                      autoComplete="off"
                      value={code}
                      onChange={this.handleChange}
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="siteInputDescription">Description</label>
                    <textarea
                      rows={5}
                      className="form-control"
                      id="siteInputDescription"
                      name="description"
                      placeholder="Enter Description"
                      autoCorrect="off"
                      value={description}
                      onChange={this.handleChange}
                    />
                    <small>
                      Support Markdown:{' '}
                      <a
                        tabIndex={-1}
                        href="https://en.support.wordpress.com/markdown-quick-reference/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Help
                      </a>
                    </small>
                  </div>
                  <div className="form-group">
                    <label htmlFor="siteInputCustomer">Customer</label>
                    <select
                      className="form-control"
                      id="siteInputCustomer"
                      name="customer_id"
                      onChange={this.handleChange}
                      value={customer_id}
                    >
                      <option />
                      {customers.rows.map((customer, i) => {
                        return (
                          <option key={i} value={customer.id}>
                            [{customer.code}]&nbsp;{customer.description}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row mt-3">
            <div className="col-12">
              <button type="submit" className="btn btn-lg btn-info" disabled={!validated}>
                <Octicon icon={CloudUpload} size="small" title="Save" />
              </button>
            </div>
          </div>
        </form>
      </div>
    );
  }

  componentDidMount() {
    setTitle('New Site');
    Customers.find({ limit: 100 }).then(customers => {
      let customer_id = this.getCustomerId();
      if (!customer_id) {
        customer_id = '';
      }
      this.setState({ customers, customer_id });
    });
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { code, description, customer_id } = this.state;
    let validated = false;
    if (code && description && customer_id) {
      validated = true;
    }
    this.setState({ validated });
  }

  handleSubmit = e => {
    e.preventDefault();
    const { code, description, customer_id, validated } = this.state;
    if (!validated) {
      return;
    }
    const payload = {
      code,
      description,
      customer_id
    };
    Sites.create(payload)
      .then(() => {
        const customer_id = this.getCustomerId();
        if (customer_id) {
          this.props.history.push('../customers/' + customer_id);
          return;
        }
        this.props.history.push('./');
      })
      .catch(err => {
        ltToast('Unable to save: ' + err.message, 5000, true);
      });
    return false;
  };

  handleChange = e => {
    this.setState({
      [e.target.name]: e.target.value
    });
  };

  getCustomerId = () => {
    const queries = qs.parse(this.props.location.search, { ignoreQueryPrefix: true });
    return queries.customer_id;
  };
}

export default SiteCreate;
